export default __webpack_public_path__ + "static/media/storno-mobile-detail.ab3cc84e.png";